module.exports = __webpack_public_path__ + "static/img/pro_display_2.dfcb1b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productDisplay/pro_display_2.jpg
// module id = J5CO
// module chunks = 1